module.exports = __webpack_public_path__ + "static/media/2_info.9ab9297a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contact/2_info.svg
// module id = 2170
// module chunks = 0